import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../actions/user";
import * as tourActions from "../../../actions/tour";

import Avatar from "material-ui/Avatar";
import Badge from "material-ui/Badge";

import IconNewApp from "material-ui/svg-icons/content/add-box";
import IconViewApps from "material-ui/svg-icons/action/assignment";
import IconMail from "material-ui/svg-icons/content/mail";
import IconLogout from "material-ui/svg-icons/action/input";
import IconOrganization from "material-ui/svg-icons/communication/business";

import IconManageOrgClients from "material-ui/svg-icons/social/people";
import SocialPerson from "material-ui/svg-icons/social/person";
import BookIcon from "@material-ui/icons/Book";
import logo from "../../../resources/logo/ac-logo-text.png";

import NormalFlatButton from "../../../components/common/NormalFlatButton";
import events from "../../../services/events";

import "./SideNav.css";
import colors from "../../../styles/colors";
import { colorsV2 } from "../../../styles/colors";

const style = {
  header: {
    backgroundColor: colorsV2.primary,
    minHeight: 55,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  list: {
    backgroundColor: colorsV2.primary,
    height: "100%",
    paddingTop: 40,
  },
  link: {
    textDecoration: "none",
  },
  subLink: {
    textDecoration: "none",
    fontSize: 12,
    margin: 2,
  },
  item: {
    left: "auto",
    marginBottom: 20,
  },
  icon: {
    marginRight: 12,
    color: "white",
  },

  text: {
    display: "inline-block",
    color: "white",
    fontSize: 18,
  },

  smallText: {
    display: "inline-block",
    color: "white",
    fontSize: 16,
  },
  subText: {
    display: "inline-block",
    color: "white",
    fontSize: 14,
  },
  footer: {
    width: 246,
    display: "flex",
    flexFlow: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  avatar: {
    margin: 5,
  },
  badge: {
    padding: "10px 5px",
  },
};

class SideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unreadMessageCount: this.countUnread(this.props.inbox),
      isProvider: this.props.isProvider,
      optionsType: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.inbox) {
      this.setState({
        unreadMessageCount: this.countUnread(nextProps.inbox),
      });
    }

    if (nextProps.userInfo) {
      this.setState({ isProvider: nextProps.isProvider });
    }

    this.setState({ optionsType: nextProps.optionsType });
  }

  countUnread(inbox) {
    let unread = 0;
    try {
      inbox.forEach((item) => {
        unread = unread + item.unreadMsgCount;
      });
    } catch (error) {}
    return unread;
  }

  render() {
    return (
      <div className={"nav-bar"}>
        <div
          className="nav-bar__logo"
          style={{
            backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
              ? this.props.whiteLabelSettings.primaryColor
              : "",
          }}
        >
          {this.props.whiteLabelSettings.isWhiteLabel && (
            <div style={{ height: "100px" }} />
          )}
          {!this.props.whiteLabelSettings.isWhiteLabel && (
            <img src={logo} alt="AC Health Logo" />
          )}
        </div>
        <div
          className="nav-bar-items"
          style={{
            backgroundColor: this.props.whiteLabelSettings.isWhiteLabel
              ? this.props.whiteLabelSettings.primaryColor
              : "",
          }}
        >
          <div style={{ width: "100%" }}>
            <Link
              to={`/view-channels/${this.props.userId}`}
              style={style.link}
              className={"step_6"}
              onClick={() => {
                try {
                  events().trackUserEvent(
                    "View Channel List",
                    null,
                    null,
                    null,
                    null,
                    this.props.user.userId,
                    null,
                    "portal",
                    null,
                    null,
                    null
                  );
                } catch (ex) {}
              }}
            >
              <div
                className={
                  this.props.optionsType === "channels"
                    ? "active nav-bar__item"
                    : "nav-bar__item"
                }
                style={{
                  backgroundColor:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel &&
                    this.props.optionsType === "channels"
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                }}
              >
                <div className="nav-bar__item-icon">
                  <IconViewApps style={style.icon} color="white" />
                </div>
                <label style={style.text}>View My Channels</label>
              </div>
            </Link>
            {this.state.isProvider && this.props.apps.providerAppId && (
              <Link
                to={"/manage-users/" + this.props.apps.providerAppId}
                style={style.link}
                onClick={() => {
                  try {
                    const app =
                      this.props.apps.appInfos[this.props.apps.providerAppId];
                    events().trackUserEvent(
                      "View Channel",
                      app.appId,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      app.appName,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <div
                  className={"nav-bar__subItem"}
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "Libraries"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <label style={style.subText}>My Patients/Clients</label>
                </div>
              </Link>
            )}
            {this.state.isProvider && this.props.apps.providerAppId && (
              <Link
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Library",
                      this.props.apps.providerAppId,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      this.props.apps.appInfos[this.props.apps.providerAppId]
                        .appName,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
                to={"/libraries/" + this.props.apps.providerAppId}
                style={style.link}
              >
                <div
                  className={"nav-bar__subItem"}
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "Libraries"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <label style={style.subText}>Manage Library</label>
                </div>
              </Link>
            )}
            {this.state.isProvider &&
              this.props.apps.providerAppId &&
              this.props.apps.appInfos[this.props.apps.providerAppId]
                .appType === "Standard" && (
                <Link
                  to={"/manage-programs/"}
                  style={style.link}
                  onClick={() => {
                    try {
                      events().trackUserEvent(
                        "View Manage Programs",
                        this.props.apps.providerAppId,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        this.props.apps.appInfos[this.props.apps.providerAppId]
                          .appName,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <div
                    className={"nav-bar__subItem"}
                    style={{
                      backgroundColor:
                        this.props.whiteLabelSettings &&
                        this.props.whiteLabelSettings.isWhiteLabel &&
                        this.props.optionsType === "Libraries"
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                    }}
                  >
                    <label style={style.subText}>Manage Programs</label>
                  </div>
                </Link>
              )}
            {this.state.isProvider &&
              this.props.apps.providerAppId &&
              this.props.apps.appInfos[this.props.apps.providerAppId]
                .appType === "Standard" && (
                <Link
                  to={"/reports/channel"}
                  style={style.link}
                  onClick={() => {
                    try {
                      events().trackUserEvent(
                        "View Channel Reports ",
                        this.props.apps.providerAppId,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        this.props.apps.appInfos[this.props.apps.providerAppId]
                          .appName,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <div
                    className={"nav-bar__subItem"}
                    style={{
                      backgroundColor:
                        this.props.whiteLabelSettings &&
                        this.props.whiteLabelSettings.isWhiteLabel &&
                        this.props.optionsType === "Libraries"
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                    }}
                  >
                    <label style={style.subText}>Channel Reports</label>
                  </div>
                </Link>
              )}
            {this.state.isProvider &&
              this.props.apps.providerAppId &&
              this.props.apps.appInfos[this.props.apps.providerAppId]
                .appType === "Standard" && (
                <Link
                  to={"/rtm/" + this.props.apps.providerAppId}
                  style={style.link}
                  onClick={() => {
                    try {
                      events().trackUserEvent(
                        "View RTM",
                        this.props.apps.providerAppId,
                        null,
                        null,
                        null,
                        this.props.user.userId,
                        null,
                        "portal",
                        this.props.apps.appInfos[this.props.apps.providerAppId]
                          .appName,
                        null,
                        null
                      );
                    } catch (ex) {}
                  }}
                >
                  <div
                    className={
                      this.props.optionsType === "RTM"
                        ? "active nav-bar__item"
                        : "nav-bar__item"
                    }
                    style={{
                      backgroundColor:
                        this.props.whiteLabelSettings &&
                        this.props.whiteLabelSettings.isWhiteLabel &&
                        this.props.optionsType === "RTM"
                          ? this.props.whiteLabelSettings.accentColor
                          : "",
                    }}
                  >
                    <div className="nav-bar__item-icon">
                      <IconViewApps style={style.icon} color="white" />
                    </div>
                    <label style={style.text}>Manage RTM</label>
                  </div>
                </Link>
              )}
            {this.props.user.isOrgAdmin && (
              <Link
                to={`/manage-org-members`}
                style={style.link}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Manage Org",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <div
                  className={
                    this.props.optionsType === "organizationMember"
                      ? "active nav-bar__item"
                      : "nav-bar__item"
                  }
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "organizationMember"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <div className="nav-bar__item-icon">
                    <IconOrganization style={style.icon} color="white" />
                  </div>
                  <label style={style.text}>Manage Organization</label>
                </div>
              </Link>
            )}
            {this.state.isProvider && this.props.organization.orgId !== -1 && (
              <Link
                to={`/manage-org-clients`}
                style={style.link}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Manage Patients/Clients",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <div
                  className={
                    this.props.optionsType === "organizationClients"
                      ? "active nav-bar__subItem"
                      : "nav-bar__subItem"
                  }
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "organizationClients"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <label style={style.subText}>Manage Patients/Clients</label>
                </div>
              </Link>
            )}
            {this.state.isProvider && this.props.organization.orgId !== -1 && (
              <Link
                to={`/org-reports`}
                style={style.link}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Org Reports",
                      null,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      null,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <div
                  className={
                    this.props.optionsType === "organizationClients"
                      ? "active nav-bar__subItem"
                      : "nav-bar__subItem"
                  }
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "organizationReports"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <label style={style.subText}>Organization Reports</label>
                </div>
              </Link>
            )}

            <Link
              to={`/message-inbox/${this.props.userId}`}
              style={style.link}
              onClick={() => {
                try {
                  events().trackUserEvent(
                    "View Message Inbox",
                    null,
                    null,
                    null,
                    null,
                    this.props.user.userId,
                    null,
                    "portal",
                    null,
                    null,
                    null
                  );
                } catch (ex) {}
              }}
            >
              <div
                className={
                  this.props.optionsType === "messages"
                    ? "active nav-bar__item step_8"
                    : "nav-bar__item step_8"
                }
                style={{
                  backgroundColor:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel &&
                    this.props.optionsType === "messages"
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                }}
              >
                <div className="nav-bar__item-icon">
                  <Badge
                    style={style.badge}
                    badgeContent={this.state.unreadMessageCount}
                    badgeStyle={{
                      backgroundColor: "white",
                      color: "black",
                    }}
                  >
                    <IconMail style={style.icon} color="white" />
                  </Badge>
                </div>
                <label style={style.text}>Message Inbox</label>
              </div>
            </Link>
            <Link
              to={`/external-resources/${this.props.userId}`}
              style={style.link}
              className={"step_7"}
              onClick={() => {
                try {
                  events().trackUserEvent(
                    "View Resource List",
                    null,
                    null,
                    null,
                    null,
                    this.props.user.userId,
                    null,
                    "portal",
                    null,
                    null,
                    null
                  );
                } catch (ex) {}
              }}
            >
              <div
                className={
                  this.props.optionsType === "external"
                    ? "active nav-bar__item"
                    : "nav-bar__item"
                }
                style={{
                  backgroundColor:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel &&
                    this.props.optionsType === "external"
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                }}
              >
                <div className="nav-bar__item-icon">
                  <BookIcon style={style.icon} />
                </div>
                <label style={style.text}>External resources</label>
              </div>
            </Link>
            {this.state.isProvider && (
              <Link
                to="/create-app"
                style={style.link}
                onClick={() => {
                  try {
                    events().trackUserEvent(
                      "View Create New Channel",
                      this.props.apps.providerAppId,
                      null,
                      null,
                      null,
                      this.props.user.userId,
                      null,
                      "portal",
                      this.props.apps.appInfos[this.props.apps.providerAppId]
                        .appName,
                      null,
                      null
                    );
                  } catch (ex) {}
                }}
              >
                <div
                  className="nav-bar__item"
                  style={{
                    backgroundColor:
                      this.props.whiteLabelSettings &&
                      this.props.whiteLabelSettings.isWhiteLabel &&
                      this.props.optionsType === "createApp"
                        ? this.props.whiteLabelSettings.accentColor
                        : "",
                  }}
                >
                  <div className="nav-bar__item-icon">
                    <IconNewApp style={style.icon} color="white" />
                  </div>
                  <label style={style.text}>Create New Channel</label>
                </div>
              </Link>
            )}
            <Link
              to={`/profile/${this.props.userId}`}
              style={style.link}
              className={"step_9"}
              onClick={() => {
                try {
                  events().trackUserEvent(
                    "View Profile",
                    null,
                    null,
                    null,
                    null,
                    this.props.user.userId,
                    null,
                    "portal",
                    null,
                    null,
                    null
                  );
                } catch (ex) {}
              }}
            >
              <div
                className={
                  this.props.optionsType === "profile"
                    ? "active nav-bar__item"
                    : "nav-bar__item"
                }
                style={{
                  backgroundColor:
                    this.props.whiteLabelSettings &&
                    this.props.whiteLabelSettings.isWhiteLabel &&
                    this.props.optionsType === "profile"
                      ? this.props.whiteLabelSettings.accentColor
                      : "",
                }}
              >
                <div className="nav-bar__item-icon">
                  <SocialPerson style={style.icon} color="white" />
                </div>
                <label style={style.text}>My Profile</label>
              </div>
            </Link>
          </div>

          <div style={style.footer}>
            <Avatar
              style={style.avatar}
              src={this.props.userInfo && this.props.userInfo.profilePhotoUrl}
              size={96}
            />
            <br />

            {this.state.isProvider && (
              <Link to="/view-channels" style={style.link}>
                <NormalFlatButton
                  style={{ color: colors.lightGrey }}
                  label="Show Guided Tour"
                  onClick={() => this.props.showTour()}
                />
              </Link>
            )}
            <Link
              to="/"
              className={"step_10"}
              onClick={() => {
                try {
                  events().trackUserEvent(
                    "Logout",
                    null,
                    null,
                    null,
                    null,
                    this.props.user.userId,
                    null,
                    "portal",
                    null,
                    null,
                    null
                  );
                } catch (ex) {}
              }}
            >
              <NormalFlatButton
                icon={<IconLogout />}
                style={{ color: "white" }}
                label="Log Out"
                onClick={() => this.props.userLogOut(-1, this.props.user.email)}
              />
            </Link>
          </div>
        </div>
      </div>
    );
  } //end render
}

function mapStateToProps({
  user,
  message,
  messages,
  apps,
  tour,
  whiteLabelSettings,
  organization,
}) {
  return {
    user,
    userId: user.userId,
    userProfile: user.profile,
    userInfo: user.userInfo,
    notifications: message.notifications,
    apps,
    inbox: messages.inbox,
    isProvider:
      user.userInfo && user.userInfo.isProvider
        ? user.userInfo.isProvider
        : false,
    tour,
    whiteLabelSettings,
    organization,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...tourActions, ...actionCreators }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);



// WEBPACK FOOTER //
// ./src/layout/Appframe/navigation/SideNav.js